import React, {Component} from 'react';
import {deleteUpload} from '../../actions/upload-actions';
import store from '../../store';


import UploadItem from '../views/upload-item';

class UploadItemContainer extends Component {
    deleteUpload() {
        store.dispatch(deleteUpload(this.props.tempUUID));
    }
    render() {
        const props = {...this.props};
        props.deleteUpload = this.deleteUpload.bind(this);
        return <UploadItem {...props}/>;
    }
}

export default UploadItemContainer;
